const ADDRESS_LINE_ONE = "line-1";
const ADDRESS_CITY = "city";
const ADDRESS_POSTCODE = "postcode";

let addressEntryClickedCallback;
let enterKey = 13;

let resetAddressError = element => {
    $(".errors-summary__link--js-anchor-member-address-" + element).parent().remove();
    $(".member-registration-error-message__member-address-" + element + "-error").addClass("errors__field-error-message--hidden");
    $("#member-address-" + element).removeClass("errors__field-error");
}

function hidePostcodeSearchForm() {
    $("#postcode-search-form").hide();
}
function hideManualAddressEntry() {
    $(".manual-address-entry").hide();
}
function showManualAddressEntry() {
    $(".manual-address-entry").show();
}
function hideSearchAddressLink() {
    $("#search-address-link").hide();
}
function showSearchAddressLink() {
    $("#search-address-link").show();
}
function hidePostcodeSearch() {
    $("#postcode-search").hide();
}
function showPostcodeSearch() {
    $("#postcode-search").show();
    $("#postcode-search-form").show();
}
function hidePostcodeSearchResults() {
    $("#postcode-search-results").hide();
}
function showPostcodeSearchError() {
    $("#postcode-search-error").show();
}
function hidePostcodeSearchError() {
    $("#postcode-search-error").hide();
}
function showUnrecognisedPostcodeError() {
    $("#postcode-invalid-error").show();
}
function hideUnrecognisedPostcodeError() {
    $("#postcode-invalid-error").hide();
}

function onManualAddressEntryClicked(callback) {
    $("#enter-address-manually").on("click", function (event) {
        event.preventDefault();
        callback();
        $("#postcode-lookup").get(0).scrollIntoView();
    });
}

function copyPostcodeToManualEntry() {
    let automaticPostcodeField = $("#postcode").val();

    if (automaticPostcodeField) {
        let manualPostcodeField = $("#member-address-postcode").val(automaticPostcodeField).parsley();
        manualPostcodeField.validate();
    }
}

function findAddressButton() {
    return $("#find-address-current");
}

function addSpinnerForFindAddressButton() {
    let addressBtn = findAddressButton();
    addressBtn.addClass("btn-loading");
}

function removeSpinnerForFindAddressButton() {
    findAddressButton().removeClass("btn-loading");
}

function onPostCodeSearch(callback) {
    $("#postcode-search").on("submit", function (event) {
        event.stopPropagation();
    });

    findAddressButton().on("click", function (event) {
        event.preventDefault();
        callback($("#postcode").val());
    });
}

function showAddresses(addressesHtml) {
    $("#postcode-search-results-placeholder").html(addressesHtml);
    $(".address-item").on("click", function (event) {
        handleAddressSelection(event, this);
    });
    $(".address-item").keypress(function(event) {
        if(event.which == enterKey) {
            handleAddressSelection(event, this);
        }
    });
    $("#postcode-search-results").show();
}

function handleAddressSelection(event, context) {
        event.preventDefault();
        addressEntryClickedCallback($(context).attr('data-address-id'));
}

function onSearchAddressClicked(callback) {
    $("#search-address-link").on("click", function (event) {
        event.preventDefault();
        callback();
        $("#postcode-lookup").get(0).scrollIntoView();
    });
    $("#search-address-button").on("click", function (event) {
        event.preventDefault();
        callback();
        $("#postcode-lookup").get(0).scrollIntoView();
    });
}

function populateManualAddressEntryFields(address) {
    $("#member-address-line-1").val(address.addressLine1);
    $("#member-address-line-2").val(address.addressLine2);
    $("#member-address-city").val(address.city);
    $("#member-address-postcode").val(address.postcode).change().parsley().validate();
    $("#member-address-country").val(address.country);
}

function populateHiddenAddressEntryFields(address) {
    $("#member-address-lookup-line-one").val(address.addressLine1);
    $("#member-address-lookup-line-two").val(address.addressLine2);
    $("#member-address-lookup-city").val(address.city);
    $("#member-address-lookup-postcode").val(address.postcode);
    $("#member-address-lookup-country").val(address.country);
}

function onAddressEntryClicked(callback) {
    addressEntryClickedCallback = callback;
}

function onEnterKeyPressedInPostcodeSearch(callback) {
    $("#postcode").keypress(callback);
}


function postcodeSearchValue() {
    return $("#postcode").val();
}

function isPostcodeSearchValueInAValidFormat() {
    let isPostcodeEmpty = postcodeSearchValue() === "";
    let isValidPostcodeFormat = $('#postcode').parsley('validate').isValid();
    return !isPostcodeEmpty && isValidPostcodeFormat;
}

function validatePostcode() {
    $('#postcode').parsley().validate();
}

function showPostcodeSearchOnLoad() {
    return $('#postcode-search').data('show-postcode-search');
}


function resetAddressErrors() {
    resetAddressError(ADDRESS_LINE_ONE);
    resetAddressError(ADDRESS_CITY);
    resetAddressError(ADDRESS_POSTCODE);

    if ($(".errors-summary li").length === 0) {
        $('.errors-summary').addClass('errors-summary--hidden');
        $('.errors-summary__list').html('');
    }

}

module.exports = {
    addSpinnerForFindAddressButton: addSpinnerForFindAddressButton,
    copyPostcodeToManualEntry: copyPostcodeToManualEntry,
    hideManualAddressEntry: hideManualAddressEntry,
    hidePostcodeSearch: hidePostcodeSearch,
    hidePostcodeSearchError: hidePostcodeSearchError,
    hidePostcodeSearchForm: hidePostcodeSearchForm,
    hidePostcodeSearchResults: hidePostcodeSearchResults,
    hideSearchAddressLink: hideSearchAddressLink,
    hideUnrecognisedPostcodeError: hideUnrecognisedPostcodeError,
    isPostcodeSearchValueInAValidFormat: isPostcodeSearchValueInAValidFormat,
    onAddressEntryClicked: onAddressEntryClicked,
    onEnterKeyPressedInPostcodeSearch: onEnterKeyPressedInPostcodeSearch,
    onManualAddressEntryClicked: onManualAddressEntryClicked,
    onPostCodeSearch: onPostCodeSearch,
    onSearchAddressClicked: onSearchAddressClicked,
    populateHiddenAddressEntryFields: populateHiddenAddressEntryFields,
    populateManualAddressEntryFields: populateManualAddressEntryFields,
    postcodeSearchValue: postcodeSearchValue,
    removeSpinnerForFindAddressButton: removeSpinnerForFindAddressButton,
    resetAddressErrors: resetAddressErrors,
    showAddresses: showAddresses,
    showManualAddressEntry: showManualAddressEntry,
    showPostcodeSearch: showPostcodeSearch,
    showPostcodeSearchError: showPostcodeSearchError,
    showPostcodeSearchOnLoad: showPostcodeSearchOnLoad,
    showSearchAddressLink: showSearchAddressLink,
    showUnrecognisedPostcodeError: showUnrecognisedPostcodeError,
    validatePostcode: validatePostcode
};